import Location from '@/ports-frontend/Location';

export const redirectToMainPage = () => {
  Location.replace('/');
};
